import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JobDetailsService {
  private hostUrl: string;

  constructor(private http: HttpClient) {
    this.hostUrl = environment.host;
  }
  // private getJobDatailsUrl = 'https://recruitmentproxytest.ameriabank.am/api/Requisition/GetRequisition';
  // private getJobsUrl = 'https://recruitmentproxytest.ameriabank.am/api/Requisition/GetActiveRequisitions';

  // GetInternalActiveRequisitions
  getJobs(lang): Observable<any> {
    return this.http.get(`${this.hostUrl}/Requisition/GetActiveRequisitions?lang=${lang}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }

  getJobDetails(id, lang): Observable<any> {
    return this.http.get(`${this.hostUrl}/Requisition/GetRequisition?id=${id}&lang=${lang}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }

  getPageUpdateDate(id): Observable<any> {
    return this.http.get(`${this.hostUrl}/Common/GetPageUpdateDate?id=${id}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }
}
